import type { ReactNode } from 'react';

export const symbol_auto_awesome_mosaic: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M451-120H180q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h271v720Zm-60-60v-600H180v600h211Zm120-331v-329h269q24 0 42 18t18 42v269H511Zm60-60h209v-209H571v209Zm-60 451v-331h329v271q0 24-18 42t-42 18H511Zm60-60h209v-211H571v211ZM391-480Zm180-91Zm0 180Z"
		/>
	</svg>
);
